export default {
  title: 'Jak oceniasz {{name}}?',
  description: 'Twoja opinia jest anonimowa i pomaga nam się doskonalić.',
  upload_google_review: {
    title: 'Oceń nas i zdobądź nagrodę',
  },
};
